import { useContext } from "react";
import { Tooltip, useDisclosure } from "@chakra-ui/react";
import { ButtonHeaderModule } from "styled/Buttons.styled";
import { IconGeneric } from "styled/Icons.styled";
import { RiEdit2Fill } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";
import { AiOutlineFileDone } from "react-icons/ai";
import { FaHistory } from "react-icons/fa";
import { AuthContext } from "context/AuthContext";
import { GiCardDiscard } from "react-icons/gi";
import IntegracionBoxCrudContex from "context/IntegracionBoxCrudContex";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { __Post } from "request/Petitions/__Post";
import { useSelector } from "react-redux";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import environment from "constants/apiConst";
import SupplyQuantitiesValidationService from "services/SupplyQuantitiesValidationService";
import { useGlobalLoading } from "utils/globalLoading";
import ModalReturnHistory from "components/modal/ModalReturnHistory";

export const ButtonsBorrador = ({
  handleCopy,
  handleEdit,
  handlePresent,
  handleEditCorrected,
  handleChangeStatusCorrected,
  valuesCorrected
}) => {
  const location = useLocation();
  const { id = null, idCorrected = null } = queryString.parse(location.search);
  const token = useSelector((state) => state.auth.dataUser.token);
  const [openAlert] = AlertErrorAlert()
  const supplyQuantitiesValidationService = new SupplyQuantitiesValidationService(token);
  const { onOpenDeleteBox, loading, setValidationQuantities, form } = useContext(IntegracionBoxCrudContex);

  const handleDesechar = async () => {
    const body = new FormData();
    body.append("form_id", id);
    body.append("type_of", ('CI'));
    body.append("type", 1);
    const res = await __Post(environment.FORMS_ON_EDIT, token, body)
    if (res?.data?.status?.code === 200) {
      setTimeout(async () => {
        body.set('type', 0)
        const res = await __Post(environment.FORMS_ON_EDIT, token, body)
      }, 5000);
      onOpenDeleteBox();
    } if (res?.data?.status?.code === 400) {
      return openAlert(res?.data?.status?.message, 'error')
    }
  };

  const handleClickEdit = async (type) => {
    const identifiers = {
      CIC: idCorrected,
      CI: id
    }
    const body = new FormData();
    body.append("form_id", identifiers[type]);
    body.append("type_of", type);
    body.append("type", 1);
    const res = await __Post(environment.FORMS_ON_EDIT, token, body)
    if (res?.data?.status?.code === 200) {
      if (type === 'CIC') {
        return handleEditCorrected()
      }
      if (type === 'CI') {
        return handleEdit()
      }
    } if (res?.data?.status?.code === 400) {
      return openAlert(res?.data?.status?.message, 'error')
    }
  }

  const handleClickPresent = async (type) => {
    const identifiers = {
      CIC: idCorrected,
      CI: id
    }
    const body = new FormData();
    body.append("form_id", identifiers[type]);
    body.append("type_of", type);
    body.append("type", 1);
    const res = await __Post(environment.FORMS_ON_EDIT, token, body)
    if (res?.data?.status?.code === 200) {
      setTimeout(async () => {
        body.set('type', 0)
        const res = await __Post(environment.FORMS_ON_EDIT, token, body)
      }, 5000);
      if (type === 'CIC') {
        return handleChangeStatusCorrected("PRESENTADO")
      }
      if (type === 'CI') {
        const isValid = await supplyValidateQuantities(form?.code_destiny);
        if (isValid) {
          return handlePresent()
        }
      }
    } if (res?.data?.status?.code === 400) {
      return openAlert(res?.data?.status?.message, 'error')
    }
  }

  const supplyValidateQuantities = async (selectedValue) => {
    const result = await supplyQuantitiesValidationService.validateQuantities(selectedValue, id);
    
    if (!result.isValid) {
      openAlert(result.message, "error");
      setValidationQuantities(result.validate_supplies_quantities);
      return false;
    }
    
    setValidationQuantities(null);
    return true;
  };

  const { isLoading: isLoadingButton } = useGlobalLoading()
  const { isOpen: isOpenReturnHistory, onOpen: onOpenReturnHistory, onClose: onCloseReturnHistory } = useDisclosure()
  
  // Obtener el form correcto según si es corrección o no
  const currentForm = idCorrected ? (valuesCorrected?.data || form?.newData?.data || form) : form;

  return (
    <>
      <ModalReturnHistory
        isOpen={isOpenReturnHistory}
        onClose={onCloseReturnHistory}
        onOpen={onOpenReturnHistory}
        title={'Historial de Devoluciones'}
        size={'3xl'}
        entryFormId={idCorrected || id}
        isOutputForm={false}
        isIntegrationCertificate={!idCorrected}
        isIntegrationCertificateCorrected={!!idCorrected}
      />
      {currentForm?.reason_for_return && (
        <Tooltip placement='top' hasArrow label='Historial de Devoluciones'>
          <span>
            <ButtonHeaderModule
              onClick={onOpenReturnHistory}
              bgColor='#FF9800'
              className='mx-1'
              isLoading={isLoadingButton}
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={FaHistory}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}
      {idCorrected
        ? (
          <>
            <Tooltip placement="top" hasArrow label="Editar">
              <span>
                <ButtonHeaderModule
                  onClick={() => handleClickEdit('CIC')}
                  className="mx-1"
                  bgColor="#1F7AC3"
                  isLoading={isLoadingButton}
                >
                  <IconGeneric width="16px" className="text-white" as={RiEdit2Fill} />
                </ButtonHeaderModule>
              </span>
            </Tooltip>

            <Tooltip placement="top" hasArrow label="Presentar">
              <span>
                <ButtonHeaderModule
                  onClick={() => handleClickPresent("CIC")}
                  className="mx-1"
                  bgColor="#1F7AC3"
                  isLoading={isLoadingButton}
                >
                  <IconGeneric
                    width="16px"
                    className="text-white"
                    as={AiOutlineFileDone}
                  />
                </ButtonHeaderModule>
              </span>
            </Tooltip>
          </>
        )
        : (
          <>
            <Tooltip placement="top" hasArrow label="Editar">
              <span>
                <ButtonHeaderModule
                  onClick={() => handleClickEdit('CI')}
                  className="mx-1"
                  bgColor="#1F7AC3"
                  isLoading={isLoadingButton}
                >
                  <IconGeneric width="16px" className="text-white" as={RiEdit2Fill} />
                </ButtonHeaderModule>
              </span>
            </Tooltip>

            <Tooltip placement="top" hasArrow label="Copiar">
              <span>
                <ButtonHeaderModule
                  onClick={handleCopy}
                  className="mx-1"
                  bgColor="#03C39A"
                  isLoading={isLoadingButton}
                >
                  <IconGeneric width="16px" className="text-white" as={MdContentCopy} />
                </ButtonHeaderModule>
              </span>
            </Tooltip>

            <Tooltip placement="top" hasArrow label="Presentar">
              <span>
                <ButtonHeaderModule
                  onClick={() => handleClickPresent('CI')}
                  className="mx-1"
                  bgColor="#1F7AC3"
                  // isLoading={loading}
                  isLoading={isLoadingButton}
                >
                  <IconGeneric
                    width="16px"
                    className="text-white"
                    as={AiOutlineFileDone}
                  />
                </ButtonHeaderModule>
              </span>
            </Tooltip>

            <Tooltip placement="top" hasArrow label="Desechar">
              <span>
                <ButtonHeaderModule
                  onClick={() => handleDesechar()}
                  className="mx-1"
                  bgColor="#d92525"
                  isLoading={isLoadingButton}
                >
                  <IconGeneric width="16px" className="text-white" as={GiCardDiscard} />
                </ButtonHeaderModule>
              </span>
            </Tooltip>
          </>
        )}
    </>
  );
};
